import * as Yup from "yup";

export const contentValidation = Yup.object({
  title: Yup.string().trim().required("Please enter a title."),
  meta: Yup.object({
    subject: Yup.string().trim().required("Please enter a subject."),
    body: Yup.string()
      .trim()
      .required("Please enter email content.")
      .min(8, "Please enter email content."),
  }),
});
